import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import moment from 'moment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Nullable } from 'primeng/ts-helpers';
import { firstValueFrom } from 'rxjs';
import { CalendarsEventsTypesService } from 'src/app/modules/calendars/_services/calendars-events-types.service';
import { CalendarsEventsService } from 'src/app/modules/calendars/_services/calendars-events.service';
import { CalendarEvent } from 'src/app/modules/calendars/_types/calendar-event';
import { GuardShiftDate } from 'src/app/modules/guards-shifts/_types/guard-shift-date';
import { WorkerCalendarEvent } from 'src/app/modules/workers/_types/worker-calendar-event';
import { CaseServiceJobComponent } from '../cases-detail/service/case-service-detail/case-service-job/case-service-job.component';
import { Case } from '../_types/case';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { CasesService } from '../_services/cases.service';
import { Filter, FilterOperation, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Job } from '../_types/job';
import { JobsService } from '../_services/jobs.service';
import { RatesTemplatesService } from '../../rates/_services/rates-templates.service';
import { RateTemplate } from '../../rates/_types/rate-template';
import { CaseServiceTransactionLinesComponent } from '../cases-detail/service/case-service-detail/case-service-transaction-lines/case-service-transaction-lines.component';
import { CasesServicesService } from '../_services/cases-services.service';
import { TransactionsLinesService } from '../../transactions/_services/transactions-lines.service';
import { TransactionLine } from '../../transactions/_types/transaction-line';
import { TransactionsDetailSummaryComponent } from '../../transactions/transactions-detail-summary/transactions-detail-summary.component';
import { TransactionsService } from '../../transactions/_services/transactions.service';
import { FilesService } from '../../common/_services/files.service';
import { CaseService } from '../_types/case-service';
import { CaseServiceDetailComponent } from '../cases-detail/service/case-service-detail/case-service-detail.component';
import { environment } from 'src/environment/environment';
import { CasesFilesService } from '../_services/cases-files.service';
import { IParamsResource } from 'src/app/core/jsonapi/interfaces/params-resource';
import { IAService } from 'src/app/core/services/ia.service';
import { Transaction } from '../../transactions/_types/transaction';
import { NumberUtilsService } from 'src/app/core/services/number-utils.service';
import { providerCase } from '../../providers/_types/provider-case.model';
import { ProviderCasesService } from '../../providers/_services/providers-cases.service';



@Component({
    selector: 'app-cases-jobs',
    templateUrl: './cases-jobs.component.html',
    styleUrls: ['./cases-jobs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CasesJobsComponent implements OnInit {  
  
  @Output() onJobsChange = new EventEmitter<void>();
  @Output() onServiceChange = new EventEmitter<void>();

  @Input() caseId: string | undefined;
  public case : Case = new Case();
  public casesServices: CaseService[] = [];
  public jobs: any = [];
  public providersCase: any = [];
  public others: any = [{name: "FRANQUICIAS, PAGOS A CUENTA Y CERTIFICACIONES", companyJobs: [],}]
  public selectedService?:CaseService | null;

  @ViewChild('opService') opService!: OverlayPanel;
    
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public workerJobs: Job[] = [];
  public groupedWorkerJobs: any = [];
  public companyJobs: Job[] = []; 
  public groupedCompanyJobs: any = []; 
  public companyJobsTotal: number = 0;
  public workerJobsTotal: number = 0;
  public displayRateTemplateModal: boolean = false;
  public ratesTemplates: RateTemplate[] = [];

  public templateId!: string;
  public transactionLinesTotal: number = 0;
  public transactionsWorker: TransactionLine[] = [];   
  public loadingTransactionsWorker: boolean = false;
  public totalTransactionsWorkerRecords: number = 0;    
  public groupedWorkers: any = [];
  public groupedProviders: any = [];
  public purchaseOrders: Transaction[] = [];
  public caseService: CaseService = new CaseService();
  public selectedServiceId: string = "";
  public activeIndexes: number[] = [];

  public imagesUrl: string = environment.api_gw + 'common/files/';
  public images: any[] = [];
  private transactions: Transaction[] = [];

  constructor(
    private dialogService: DialogService,
    private casesService: CasesService,
    private jobsService: JobsService,
    private ratesTemplatesService: RatesTemplatesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private casesServicesService: CasesServicesService,
    private transactionLinesService: TransactionsLinesService,
    private transactionsService: TransactionsService,
    private filesService: FilesService,
    private casesFilesService: CasesFilesService,
    private iaService: IAService,
    private numberUtilsService: NumberUtilsService,
    private providerCasesService: ProviderCasesService
  ) {    
  }

  ngOnInit(): void {     
    
    this.allowWrite = true;//this.loginService.hasPermission("CASE_SERVICES_WRITE");
    this.allowDelete = true;//this.loginService.hasPermission("CASE_SERVICES_DELETE");  
  }

  async loadCase() {    
      let params:IParamsResource = {
        include: ['clientPolicy', 'caseState']
      };
      this.case = await firstValueFrom(this.casesService.get(this.caseId!, params));     
      await this.loadCasesServices();
  }

  async loadCasesServices() {
    //creamos filtros
    let params: IParamsCollection = {
      sort: ['date']
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),      
      dateEnd: new NotFilter(FilterOperation.equals, "dateEnd",'',null,true),
    };

    filters.caseId.value = this.case.id;
    params.filter = FilterBuilder.fromObject(filters).build();
    params.include = ['worker', 'caseNotificationNumber'];    

    let response = await firstValueFrom(this.casesServicesService.all(params));
    this.casesServices = response.data;
    
    const workerMap:any = {};

    this.casesServices.forEach((service:any) => {
      const workerId = service.workerId;
      if (!workerMap[workerId]) {
        workerMap[workerId] = {
          workerId: workerId,
          workerName: service.worker?.name,
          hasSubmitInvoice:service.worker?.hasSubmitInvoice,
          services: []
          //workerServices: [],          
        };
      }      
      service.hasTransactions = this.hasTransacions(service.id);
      workerMap[workerId].services.push({
        ...service        
      });

    });

    this.groupedWorkers = Object.values(workerMap);      
  }

  async loadProvidersCase(){

    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId",'',this.caseId)
    };
    const filter = FilterBuilder.fromObject(filters).build();
   let params: IParamsCollection = {
      page: { number: 0, size: 100 },
      filter: filter
    };
    let response = await firstValueFrom(this.providerCasesService.all(params));
    this.providersCase = response.data;
  }


  async loadJobs() {
    this.selectedServiceId = "";

    const pageSize = 100;
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId",'',this.caseId),
      caseService: new OrFilter([
        new Filter(FilterOperation.equals, "caseService.deleted", '', false),
        new Filter(FilterOperation.equals, "caseServiceId", '', null, true)
      ])
    };
    const filter = FilterBuilder.fromObject(filters).build();

    // Iteramos por páginas hasta traer todos los trabajos (hay servicios con más de 100). ejemplo 3524010456
    // OJO: ParamsBuilder interpreta page.number como el índice del primer registro (offset),
    // no como el número de página, así que avanzamos de pageSize en pageSize.
    let allJobs: any[] = [];
    let offset = 0;
    while (true) {
      let params: IParamsCollection = {
        include: [
          'rateLine', 'transaction.transactionType','transaction.transactionState', 
          'caseService', 'worker', 'transaction.relatedTransaction', 
          'transaction.relatedTransaction.transactionState', 'provider',
          'purchaseTransaction','purchaseTransaction.transactionState'
        ],
        page: { number: offset, size: pageSize },
        filter: filter
      };

      let response = await firstValueFrom(this.jobsService.all(params));
      allJobs = allJobs.concat(response.data);

      const total = response.meta['total'];
      const hasMoreByTotal = total != null && allJobs.length < total;
      const hasMoreByPage = total == null && response.data.length === pageSize;
      if (!hasMoreByTotal && !hasMoreByPage) {
        break;
      }
      offset += pageSize;
    }
    this.jobs = allJobs;
  }


  async loadTransactionsWorker() {
    let params: IParamsCollection = {  
      include: ['transaction.transactionState', 'caseService']    
    }
    let filters: any = {        
      caseId: new Filter(FilterOperation.equals, "transaction.caseId",'',this.caseId),
      transactionType: new Filter(FilterOperation.equals, "transaction.transactionType.code",'',"incoming_invoice")
    };
    
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.transactionLinesService.all(params));    

    this.transactionsWorker = response.data;    

    this.transactionLinesTotal = (this.transactionLinesTotal || 0) + this.transactionsWorker.reduce((sum, item) => sum + item.subtotal, 0);
    this.totalTransactionsWorkerRecords = response.data.length;
    
  }

  async loadTransactionPurchaseOrders(){
    // Buscamos las ordenes de compra asociadas para mostrarlos.
    let params: IParamsCollection = {  
      include: ['transactionState', 'thirdParty','transactionType']    
    }
    let filters: any = {        
      caseId: new Filter(FilterOperation.equals, "caseId",'',this.caseId),
      //transactionType: new Filter(FilterOperation.equals, "transactionType.code",'',"purchase_order")
      transactionTypeCode: new Filter(FilterOperation.any, "transactionType.code", '', ['purchase_order', 'ingoing_budget_worker', 'company_outgoing_budget', 'outgoing_budget'])
    };
    
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.transactionsService.all(params));    
    this.purchaseOrders = response.data.filter((m : any) => m.transactionType.code == "purchase_order");
    this.transactions = response.data.filter((m : any) => m.transactionType.code != "purchase_order");
    this.loadPurchaseOrdersData();
  }

  editService(caseService: CaseService) {
    let ref = this.dialogService.open(CaseServiceDetailComponent, {
      closable: true,
      modal: true,
      header: 'Ficha de servicio',
      width: '80%',
      data: {
        caseId: this.case.id,
        caseServiceId: caseService ? caseService.id : null,
        showLilnkCase: true
      }
    });

    ref.onClose.subscribe((data: any) => {
      caseService.isValidated = data.isValidated;
    });
  }

  editJob(type:string, job: any, caseService?: any, workerId?: string | null, providerId?: string | null, retry: number = 0){

    if(this.case.caseState != null && this.case.caseState.isFinal) {
      this.messageService.add({ closable: true, severity: 'error', detail: "No se pueden modificar o crear trabajos en un expediente cerrado." });
      return;
    }

    const ref = this.dialogService.open(CaseServiceJobComponent, {
      closable: true,
      header: 'Datos generales',
      width: '60%',
      draggable: true,
      modal: false,
      data: {        
        type: type,
        companyId: this.case?.companyId, 
        contractId: this.case?.contractId,        
        caseId: this.caseId,
        caseServiceId: caseService?.id,
        capabilityId: caseService?.capabilityId,
        workerId: workerId,
        id: job!=null?job.id:null,
        insuranceCompanyId: this.case.clientPolicy?.insuranceCompanyId,
        isGuard: caseService?.isGuard ?? false,
        providerId: providerId,
      }
    });

    if(!ref || !ref.onClose) {
      if(retry < 3){
        setTimeout(() => {
          this.editJob(type, job, caseService, workerId, providerId, retry+1);
        }, 150);
      }
      return;
    }

    
    ref.onClose.subscribe(async (data: any) => {      
      this.onJobsChange.emit();
      this.loadJobsAndRest();
      job = data;
      if(data) this.editJob(type, job, caseService, workerId, providerId);
    });
  }

  deleteJob(job:any) {    
      this.confirmationService.confirm({
        message: (job.rateLine != null ? "¿Está seguro que desea eliminar el trabajo "+job.rateLine?.code+"?" : "¿Está seguro que desea eliminar el trabajo?"),
        header: "Eliminar trabajo",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.jobsService.delete(job.id).subscribe({
            next: () => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Trabajo eliminado correctamente." });                        
              this.loadJobsAndRest();
              this.onJobsChange.emit();
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {        
        }
      });
    }  

  async importRateTemplate(type:string, caseServiceId: string){ 
        
    if(this.case.caseState != null && this.case.caseState.isFinal) {
      this.messageService.add({ closable: true, severity: 'error', detail: "No se pueden modificar o crear trabajos en un expediente cerrado." });
      return;
    }

    this.displayRateTemplateModal = true;
    this.selectedServiceId = caseServiceId;

    let filters = {
      //typeOfRate: new Filter(FilterOperation.equals, 'rate.typeOfRate', "", type=="COMPANY"?0:1)
      typeOfRate: new Filter(FilterOperation.equals,  'rate.typeOfRate', "", type=="COMPANY"?'0': type=="WORKER"?'1':'2')

    };
    let params: IParamsCollection = {
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    }
    //cargamos las plantillas 
    let response = await firstValueFrom(this.ratesTemplatesService.all(params));
    this.ratesTemplates = response.data;

    this.onJobsChange.emit();
  }  


  importTransactionLines(type:string, caseServiceId?: string | null, workerId?: string| null, providerId?: string| null){
    if(this.case.caseState != null && this.case.caseState.isFinal) {
      this.messageService.add({ closable: true, severity: 'error', detail: "No se pueden modificar o crear trabajos en un expediente cerrado." });
      return;
    }

    let ref = this.dialogService.open(CaseServiceTransactionLinesComponent, {
      closable: true,
      header: 'Datos generales',
      width: '50%',
      draggable: true,
      modal: false,
      data: {        
        type: type,
        companyId: this.case?.companyId,        
        caseId: this.caseId,
        caseServiceId: caseServiceId,
        workerId: workerId,       
        providerId: providerId 
      }
    });

    ref.onClose.subscribe((data: any) => {      
      //this.loadJobs();
      this.loadJobsAndRest();
      this.onJobsChange.emit();
    });
  }

  async saveRateTemplate(){    
    if(typeof this.templateId != "undefined"){
      var data = await firstValueFrom(this.casesServicesService.generateJobsByTemplate(this.selectedServiceId!, this.templateId));                  
      this.displayRateTemplateModal = false;
      //this.loadJobs();
      this.loadJobsAndRest();
      this.onJobsChange.emit(); 
    }else{
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Debe seleccionar una plantilla." });
    }    
  }

  hideRateTemplateModal() {
    this.displayRateTemplateModal = false;
  }

  getProfitPercent(worker:any):number{
    var info = this.getWorkerJobsTotal(worker);
    return info.subtotalCompany>0?((info.subtotalCompany - info.subtotalWorker /*- info.totalWorkerInvoices*/) * 100 / info.subtotalCompany):0;
  }

  getProfit(worker:any):number{
    var info = this.getWorkerJobsTotal(worker);
    return (info.subtotalCompany - info.subtotalWorker /*- info.totalWorkerInvoices*/);
  }

  getWorkerJobsTotal(worker:any){ 
    const subtotalCompany = this.jobs.reduce((sum:any, job:any) => sum + (job.workerId == worker.workerId && job.isForCompany == true? (job.subtotal): 0), 0);
    const totalCompany = this.jobs.reduce((sum:any, job:any) => sum + (job.workerId == worker.workerId && job.isForCompany == true? job.total : 0), 0);
    const subtotalWorker = this.jobs.reduce((sum:any, job:any) => sum + (job.workerId == worker.workerId && job.isForCompany == false?  (job.subtotal): 0), 0);
    const totalWorker = this.jobs.reduce((sum:any, job:any) => sum + (job.workerId == worker.workerId && job.isForCompany == false? job.total : 0), 0);
   
    const subtotalWorkerInvoices = this.transactionsWorker.filter((transactionLine: any) => transactionLine.transaction.thirdPartyId == worker.workerId).reduce((sum:any, transactionLine:any) => sum + transactionLine.transaction.subtotal, 0);
    const totalWorkerInvoices = this.transactionsWorker.filter((transactionLine: any) => transactionLine.transaction.thirdPartyId == worker.workerId).reduce((sum:any, transactionLine:any) => sum + transactionLine.transaction.subtotal, 0);
  
    const subtotalMaterials = this.jobs.reduce((sum:any, job:any) => sum + (job.workerId == worker.workerId && job.isForCompany == false && job.providerId != null ?  (job.subtotal): 0), 0);
    const totalMaterials = this.jobs.reduce((sum:any, job:any) => sum + (job.workerId == worker.workerId && job.isForCompany == false && job.providerId != null ?  (job.total): 0), 0);
    //  se borra /*+ getWorkerJobsTotal(worker).totalWorkerInvoices*/ en el TOTAL coste porque pueden/deben añadir trabajos manualmente y luego adjuntan la factura.
    //TODO: Pide que si añaden la factura, se añada aqui automaticamente... para que puedan cerrar el expediente.

    return {
      subtotalCompany:this.numberUtilsService.Round(subtotalCompany),
      totalCompany: this.numberUtilsService.Round(totalCompany),
      subtotalWorker: this.numberUtilsService.Round(subtotalWorker),
      totalWorker: this.numberUtilsService.Round(totalWorker),      
      subtotalMaterials: this.numberUtilsService.Round(subtotalMaterials),
      totalMaterials: this.numberUtilsService.Round(totalMaterials),
     // totalWorkerInvoices: totalWorkerInvoices
    }    
  }

  getProfitProvidersPercent(provider:any):number{
    var info = this.getProviderJobsTotal(provider);
    return info.subtotalCompany>0?((info.subtotalCompany - info.subtotalProvider /*- info.totalWorkerInvoices*/) * 100 / info.subtotalCompany):0;
  }

  getProfitProviders(provider:any):number{
    var info = this.getProviderJobsTotal(provider);
    return (info.subtotalCompany - info.subtotalProvider /*- info.totalWorkerInvoices*/);
  }

  getProviderJobsTotal(provider: any){       
    const subtotalCompany = this.jobs.reduce((sum:any, job:any) => sum + (job.providerId == provider.id && job.isForCompany == true? (job.subtotal): 0), 0);
    const totalCompany = this.jobs.reduce((sum:any, job:any) => sum + (job.providerId == provider.id && job.isForCompany == true? job.total : 0), 0);
    const subtotalWorker = this.jobs.reduce((sum:any, job:any) => sum + (job.providerId == provider.id && job.isForCompany == false?  (job.subtotal): 0), 0);
    const totalWorker = this.jobs.reduce((sum:any, job:any) => sum + (job.providerId == provider.id && job.isForCompany == false? job.total : 0), 0);
     return {
      subtotalCompany: subtotalCompany,
      totalCompany: totalCompany,
      subtotalProvider: subtotalWorker,
      totalProvider: totalWorker,
     // totalWorkerInvoices: totalWorkerInvoices
    }    
  }
  
  getOtherPercent(provider:any):number{
    var info = this.getOtherJobsTotal(provider);
    return info.subtotalCompany>0?((info.subtotalCompany) * 100 / info.subtotalCompany):0;
  }

  getOther(provider:any):number{
    var info = this.getOtherJobsTotal(provider);
    return (info.subtotalCompany );
  }

  getOtherJobsTotal(provider: any){       
    const subtotalCompany = this.jobs.reduce((sum:any, job:any) => sum + (job.providerId == null && job.workerId == null && job.caseServiceId == null && job.isForCompany == true? (job.subtotal): 0), 0);
    const totalCompany = this.jobs.reduce((sum:any, job:any) => sum + (job.providerId == null && job.workerId == null && job.caseServiceId == null && job.isForCompany == true? job.total : 0), 0);
     return {
      subtotalCompany: subtotalCompany,
      totalCompany: totalCompany
    }    
  }

  getWorkersSummary() {
    const totalCompanyJobs = this.jobs.reduce((sum:any, job:any) => sum + (job.isForCompany?job.total:0), 0);    
    const totalWorkerJobs = this.jobs.reduce((sum:any, job:any) => sum + (!job.isForCompany?job.total:0), 0);
    const totalProfit = totalCompanyJobs - totalWorkerJobs;
    const totalProfitPercent = totalCompanyJobs > 0 ? (totalProfit * 100) / totalCompanyJobs : 0;
  
    return {
      totalCompanyJobs,
      totalWorkerJobs,
      totalProfit,
      totalProfitPercent
    };
  }

  getWorkerTransactionsTotal(worker:any){        
    return this.transactionsWorker.reduce((sum:any, transactionLine:any) => sum + (transactionLine.transaction.thirdPartyId == worker.workerId? transactionLine.transaction.subtotal : 0), 0);    
  }

  async editTransaction(transactionId: any, caseServiceId: string, workerId: string) {  
    
    let caseService = await firstValueFrom(this.casesServicesService.get(caseServiceId));
    let ref = this.dialogService.open(TransactionsDetailSummaryComponent, {
      closable: true,
      header: 'Datos generales',
      width: '50%',
      draggable: true,

      modal: false,
      data: {        
        thirdPartyId: workerId,    
        thirdPartyType: "Worker",
        transactionType: "incoming_invoice",
        caseId: this.caseId,
        caseServiceId: caseServiceId,
        workerId: workerId,
        transactionId: transactionId        
      }
    });

    ref.onClose.subscribe((data: any) => {       
      //Guardamos el caseService con el transaction.
      if(typeof data != "undefined"){
        caseService.transactionId = data.id;
        firstValueFrom(this.casesServicesService.save(caseService));
        this.loadTransactionsWorker();
      }
    });

  }

  deleteTransaction(transactionLine:any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la factura "+transactionLine.transaction?.code+"?",
      header: "Eliminar factura",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // Borramos la factura (transacción). La fila cuelga de la transacción vía transactionId,
        // así que al quedar borrada deja de devolverse en loadTransactionsWorker y desaparece.
        this.transactionsService.delete(transactionLine.transactionId).subscribe({
          next: () => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Eliminada correctamente." });
            this.loadTransactionsWorker();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
      }
    });
  }

  downloadFile(id: any) {
    if (id != null && id != "") {
      this.filesService.download(id);
    }
  }

  async goToTransaction(transactionId:string, transactionTypeCode: string){
    window.open("/transactions/"+transactionTypeCode+"/" + transactionId, "_blank");
  }  

  getFilteredJobs(service: any, worker: any, isForCompany: boolean) {
    return this.jobs.filter((job: any) => job.workerId === worker.workerId && job.caseServiceId === service.id && job.isForCompany === isForCompany);
  }

  getFilteredJobsProviders(  provider: any, isForCompany: boolean) {
    return this.jobs.filter((job: any) => job.providerId === provider.thirdPartyId  && job.isForCompany === isForCompany);
  }

  getFilteredJobsOthers(  provider: any, isForCompany: boolean) {
    return this.jobs.filter((job: any) => job.providerId === null && job.workerId == null && job.caseServiceId == null  && job.isForCompany === isForCompany);
  }

  getFilteredTransactionLines(service: any, worker: any) {
    return this.transactionsWorker.filter((transactionLine: any) => transactionLine.transaction.thirdPartyId === worker.workerId && transactionLine.caseServiceId === service.id);
  }

  async openServiceOp($event:any, service:CaseService){
    this.selectedService = service;
    let params: IParamsCollection = {
      include: ['file'],      
    }
    let filters: any = {
      caseServiceId: new Filter(FilterOperation.equals, "caseServiceId"),      
    };

    filters.caseServiceId.value = this.selectedService.id;    

    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesFilesService.all(params));    
    this.images = response.data;    

    this.opService.toggle($event);
  }

  loadPurchaseOrdersData(){
    const providerMap:any = {};
    this.purchaseOrders.forEach((service:any) => {
      const thirdPartyId = service.thirdPartyId;
      if (!providerMap[thirdPartyId]) {
        providerMap[thirdPartyId] = {
          id: service.thirdParty?.id,
          thirdPartyId: service.thirdParty?.id,
          name: service.thirdParty?.name,
          deleted: service.thirdParty?.deleted,
          companyJobs: [],
           providerJobs: [],
          hasTransaction: this.purchaseOrders.find((po:any) => po.thirdPartyId === service.thirdParty?.id) ? true : false
        };
      }      
      providerMap[thirdPartyId].companyJobs = this.jobs.filter((job: any) => job.providerId === thirdPartyId  && job.isForCompany === true);
      providerMap[thirdPartyId].providerJobs = this.jobs.filter((job: any) => job.providerId === thirdPartyId  && job.isForCompany === false);      
      var providerCase = this.providersCase.filter((m: any) => m.providerId === thirdPartyId)[0];
      providerMap[thirdPartyId].companyJobsNoRequired = providerCase ? providerCase.companyJobsNoRequired : false;
      providerMap[thirdPartyId].providersCases = providerCase;

    });

    //Obtenemos todos los jobs que tengan providerId y que no estén en la lista de ordenes de compra. (Caso de expedientes migrados)
    const otherProvidersJobs = this.jobs.filter((job: any) => job.providerId != null && !this.purchaseOrders.some((po:any) => po.thirdPartyId === job.providerId));
    
    otherProvidersJobs.forEach((job:any) => {
      
      if (job.provider != null && !providerMap[job.provider.id]) {
        providerMap[job.provider.id] = {
          id: job.provider.id,
          thirdPartyId: job.provider.id,
          name: job.provider.name,
          deleted: job.provider.deleted,
          companyJobs: [],
          providerJobs: []
        };
        
        providerMap[job.provider.id].companyJobs = this.jobs.filter((jobf: any) => jobf.providerId === job.provider?.id  && jobf.isForCompany === true);
        providerMap[job.provider.id].providerJobs = this.jobs.filter((jobf: any) => jobf.providerId === job.provider?.id  && jobf.isForCompany === false);      
        var providerCase = this.providersCase.filter((m: any) => m.providerId === job.provider.id)[0];
        providerMap[job.provider.id].companyJobsNoRequired = providerCase ? providerCase.companyJobsNoRequired : false;
        providerMap[job.provider.id].providersCases = providerCase;
      }
    });

    this.groupedProviders = Object.values(providerMap); 
  }

  async loadJobsAndRest(){
    await this.loadJobs();
    this.loadPurchaseOrdersData(); 
    this.loadOthers();
    this.loadProvidersCase();
  }

  async reload() {
    await this.loadJobs();
    this.loadCase();
    this.loadTransactionsWorker();
    this.loadTransactionPurchaseOrders();
    this.loadOthers();
    this.loadProvidersCase();
  }

  loadOthers(){
    const otherJobs = this.jobs.filter((job: any) => job.providerId == null && job.workerId == null && job.caseServiceId == null);
    this.others[0].companyJobs = otherJobs;
  }

  getTooltipImage(image: any): string {
    return `<img src="${this.imagesUrl + image.fileId + '/download'}" width="500" height="500" style="border-radius: 5px;"/>`;
  }

  async requestAIGenerate(service: CaseService) {
    if(this.case.caseState != null && this.case.caseState.isFinal) {
      this.messageService.add({ closable: true, severity: 'error', detail: "No se pueden modificar o crear trabajos en un expediente cerrado." });
      return;
    }

    let response = await firstValueFrom(this.iaService.caseServiceJobGenerate(service));
    this.confirmationService.confirm({
      message: "Se ha solicitado la generación de trabajos a IA. Los trabajos pueden tardar unos minutos en aparecer, en la sección de eventos encontrará un registro en caso de error.",
      header: "Solicitud enviada",
      acceptLabel: "Aceptar",
      rejectVisible: false
    });
  }

  async caseServiceValidated(service: CaseService, worker: any){

    //comporbamos si todos los trabajos están validados.
    var allJobs = this.jobs.filter((job: any) => job.workerId === worker.workerId && job.caseServiceId === service.id && !job.isReview );
    if(allJobs.length != 0){
      this.messageService.add({ closable: true, severity: 'error', detail: "Debe revisar todos los trabajos del servicio para validarlo.", life: 5000 });
      return;
    }else{
      service.isValidated = true;
      await firstValueFrom(this.casesServicesService.save(service));
      this.messageService.add({ closable: true, severity: 'success', detail: "Cita validada correctamente." });
      this.onJobsChange.emit();
      this.onServiceChange.emit();
    }
    
  }

  getBorderStyle(companyJob:Job): string {
    let style = '4px solid transparent';
    if(companyJob.isReview && companyJob.isBillable){
      style = '4px solid #22C55E';
    }else if(companyJob.isReview || companyJob.isBillable){
      style = '4px solid #F59E0B';
    }
    return style;
  }

  isServiceJobsAllReviewed(service: CaseService, isForCompany:boolean){
    let hasNoReviewedJobs = this.jobs.filter((job: any) => job.caseServiceId === service.id && !job.isReview && job.isForCompany == isForCompany).length == 0;
    let hasJobs = this.jobs.filter((job: any) => job.caseServiceId === service.id && job.isForCompany == isForCompany).length == 0;
    return hasNoReviewedJobs && !hasJobs;
  }

  isServiceJobsAllBillable(service: CaseService, isForCompany:boolean){
    let hasNoBillableJobs = this.jobs.filter((job: any) => job.caseServiceId === service.id && !job.isBillable && job.isForCompany == isForCompany).length == 0;
    let hasJobs = this.jobs.filter((job: any) => job.caseServiceId === service.id && job.isForCompany == isForCompany).length == 0;
    return hasNoBillableJobs && !hasJobs;
  }

  async toogleCompanyJobsNoRequired(event:any, service: CaseService) {
    service.companyJobsNoRequired = event.checked;
    await firstValueFrom(this.casesServicesService.save(service));
  }

  async toogleWorkerJobsNoRequired(event:any, service: CaseService) {
    service.workerJobsNoRequired = event.checked;
    await firstValueFrom(this.casesServicesService.save(service));
  }

  async toggleReviewed(event:any, service: CaseService, isForCompany:boolean) {
    let jobs = this.jobs.filter((job: any) => job.caseServiceId === service.id && job.isForCompany == isForCompany);
    for(let job of jobs) {
      if(job.transactionId==null && job.isReview != event.checked) {
        job.isReview = event.checked;
        await firstValueFrom(this.jobsService.save(job));
      }
    }
  }

  async toggleBillable(event:any, service: CaseService, isForCompany:boolean) {
    let jobs = this.jobs.filter((job: any) => job.caseServiceId === service.id && job.isForCompany == isForCompany);
    for(let job of jobs) {
      if(!job.isReview && event.checked) // No se puede marcar como facturable un trabajo que no esté revisado
        continue;
      if(job.transactionId==null && job.isBillable != event.checked) {
        job.isBillable = event.checked;
        await firstValueFrom(this.jobsService.save(job));
      }
    }
  }


  async toogleProviderCompanyJobsNoRequired(event:any, provider: any) {
    if(provider.providersCases){
      provider.providersCases.companyJobsNoRequired = event.checked;
      await firstValueFrom(this.providerCasesService.save(provider.providersCases));
      await this.loadProvidersCase();
    }else{
      let providerCase_ = new providerCase();
      providerCase_.caseId = this.case?.id ?? '';
      providerCase_.providerId = provider.thirdPartyId;
      providerCase_.companyJobsNoRequired = event.checked;
      await firstValueFrom(this.providerCasesService.save(providerCase_));
      await this.loadProvidersCase();
    }    
    await this.loadPurchaseOrdersData();
  }

  checkIfServiceMigrated(worker:any): boolean {
    let apuyenServices = worker.services.filter((service:any) => service.externalId != null && !service.externalId.startsWith("SendedToApuyen"));
    return apuyenServices.length > 0;
  }

  hasTransacions(serviceId: string): number {
    let hasTransactions = this.transactions.filter((transactionLine: any) => transactionLine.caseServiceId === serviceId);
    return hasTransactions ?  hasTransactions.length : 0;
  }
  
}
